import React from 'react'
import { useLocation, useParams, Link } from 'react-router-dom'

export default function OrderComplete(){
  const { oid } = useParams()
  const q = new URLSearchParams(useLocation().search)
  const paymentId = oid || q.get('paymentId') || q.get('id') || ''
  const status = q.get('status') || q.get('result') || 'completed'
  const amount = q.get('amount') || ''

  return (
    <div className="container-custom mx-auto px-6 py-12">
      <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
        <h2 className="text-2xl font-semibold mb-4">Order Complete</h2>
        <p className="text-gray-700 mb-4">Thank you — your payment has been processed.</p>
        <div className="mb-3">
          <strong>Status:</strong> <span className="text-green-600">{status}</span>
        </div>
        {paymentId ? (
          <div className="mb-3"><strong>Payment ID:</strong> {paymentId}</div>
        ) : null}
        {amount ? (
          <div className="mb-3"><strong>Amount:</strong> ₹{amount}</div>
        ) : null}
        <div className="mt-4">
          <Link to="/" className="px-4 py-2 bg-brand text-white rounded">Continue Shopping</Link>
        </div>
      </div>
    </div>
  )
}
